import { AddTextIcon } from './add-text';

const icons = {
  AddTextIcon
};

export const keys = Object.keys(icons);

export default icons;
